module.exports = __webpack_public_path__ + "img/cast_events_noevents@2x.a38aa586.png";